import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from './Loading';
import { fetchPostById } from './postData';
import { getSetupPath } from './setupContent';
import { usePageSeo } from './seo';

const Shared = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [resolved, setResolved] = useState(false);

  usePageSeo({
    title: 'Redirecting to setup',
    description: 'Redirecting to the canonical 101Setups setup page.',
    canonicalPath: `/shared/${id}`,
    robots: 'noindex,nofollow',
  });

  useEffect(() => {
    let isMounted = true;

    const redirectToCanonicalRoute = async () => {
      const post = await fetchPostById(id);

      if (!isMounted) {
        return;
      }

      if (post) {
        navigate(getSetupPath(post), { replace: true });
        return;
      }

      setResolved(true);
    };

    redirectToCanonicalRoute();

    return () => {
      isMounted = false;
    };
  }, [id, navigate]);

  if (!resolved) {
    return <Loading />;
  }

  return (
    <section className="page-shell">
      <div className="empty-state">
        <h1>Setup not found</h1>
        <p>The shared link could not be resolved. Try browsing the latest setups instead.</p>
      </div>
    </section>
  );
};

export default Shared;
